import { variant } from 'styled-system';

export const TextSizeArray = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'xxlarge',
    'xxxlarge',
] as const;
type TextSizeTuple = typeof TextSizeArray;
export type TextSize = TextSizeTuple[number];

type TextSizeProps = {
    fontSize: string;
    lineHeight: string;
};

export const textSizeVariant = variant<TextSizeProps, TextSize>({
    prop: 'textSize',
    variants: {
        xxsmall: {
            fontSize: '10px',
            lineHeight: '16px',
        },
        xsmall: {
            fontSize: '12px',
            lineHeight: '18px',
        },
        small: {
            fontSize: '14px',
            lineHeight: '20px',
        },
        medium: {
            fontSize: '16px',
            lineHeight: '22px',
        },
        large: {
            fontSize: '18px',
            lineHeight: '24px',
        },
        xlarge: {
            fontSize: '20px',
            lineHeight: '24px',
        },
        xxlarge: {
            fontSize: '22px',
            lineHeight: '26px',
        },
        xxxlarge: {
            fontSize: '24px',
            lineHeight: '30px',
        },
    },
});
